// extracted by mini-css-extract-plugin
export default {"text":"commonStyles_text__tGyii"};